<template>
  <header>
    <h1>
      <router-link :to="{
        name: 'Feature',
        params: { uuid: feature.id }
      }">
        {{ feature.name }}
      </router-link>
    </h1>
  </header>
</template>

<script>
export default {
  props: ["feature"]
}
</script>



// WEBPACK FOOTER //
// src/components/Feature/EmbeddedHeader.vue